
import { useState } from "react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";
import { PinFormData } from "@/components/pins/PinForm";

export function usePinCreation() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  
  const createPin = async (formData: PinFormData, userId: string | null) => {
    setError(null);
    
    if (!userId) {
      toast.error("Você precisa estar logado para criar um pin.");
      navigate("/auth");
      return;
    }
    
    if (!formData.imageUrl || !formData.title) {
      toast.error("Por favor, preencha todos os campos obrigatórios.");
      return;
    }

    setIsLoading(true);
    
    try {
      const { error: insertError } = await supabase.from("posts").insert({
        title: formData.title,
        description: formData.description,
        image_url: formData.imageUrl,
        user_id: userId,
        category: formData.category || "other", // Default to "other" if no category is selected
        is_for_sale: formData.isForSale,
      });

      if (insertError) {
        console.error("Erro no insert:", insertError);
        setError(insertError.message);
        throw insertError;
      }

      toast.success("Seu pin foi publicado e já está disponível para visualização.");
      navigate("/");
    } catch (error: any) {
      console.error("Erro completo:", error);
      setError(error.message || "Erro desconhecido");
      toast.error("Ocorreu um erro ao tentar criar seu post. Tente novamente.");
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    createPin
  };
}
